import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import {
	setArticlePacketsAssignedQuery,
	fetchArticlePacketsAssigned
} from 'store/actions';

// Import columns
import { createColumns } from './articles_packets_assigned_columns';

// Import utilities
import Search from 'components/utilities/search/Search';

// Import components
import { PanelPageTemplate } from 'components/common/templates';

const ArticlesPacketsAssigned = ({
	error,
	setArticlePacketsAssignedQuery,
	fetchArticlePacketsAssigned,
	resources,
	match: {
		params: { id }
	}
}) => {
	return (
		<PanelPageTemplate
			itemId={id}
			title="Lista"
			error={error}
			type="packets_assigned"
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchArticlePacketsAssigned}
		>
			<div className="d-flex justify-content-end">
				<Search
					setQueryValue={setArticlePacketsAssignedQuery}
					value={resources.options.filters.query}
				/>
			</div>
		</PanelPageTemplate>
	);
};

ArticlesPacketsAssigned.propTypes = {
	error: PropTypes.bool.isRequired,
	setArticlePacketsAssignedQuery: PropTypes.func.isRequired,
	resources: PropTypes.object.isRequired,
	fetchArticlePacketsAssigned: PropTypes.func.isRequired
};

const mapStateToProps = ({ articles }) => {
	return {
		error: articles.packets_assigned.error,
		resources: articles.packets_assigned
	};
};

export default compose(
	connect(mapStateToProps, {
		setArticlePacketsAssignedQuery,
		fetchArticlePacketsAssigned
	}),
	withRouter
)(ArticlesPacketsAssigned);
